<template>
  <div class="page">
    <h3 v-if="!hideTitle">결제내역 수동 저장</h3>

    <div class="toolbar">
      <!-- 20006 검색조건 배치(좌측): 조회 / 삭제 / 전체삭제 / 불러오기 제외할 cafe24 주문 / 업로드 (입력칸 제거) -->
      <button @click="reload">조회</button>
      <button class="ghost" @click="removeOne">삭제</button>
      <button class="ghost" @click="removeAll">전체삭제</button>
      <button class="ghost" @click="excludeOpen=true">불러오기 제외할 cafe24 주문</button>
      <!-- 업로드 버튼은 admin role 만 표시. 클릭 시 [결제내역 조회에서 진입하는 업로드 팝업] 표시 -->
      <button v-if="isAdmin" class="ghost" @click="importOpen=true">업로드</button>
      <!-- 20006 검색조건 배치(우측): 불러오기(녹색) / 결제내역에 적용(적색) -->
      <span class="spacer"></span>
      <button class="recv" @click="collectReceive" :disabled="collecting">{{ collecting ? '불러오는 중…' : '불러오기' }}</button>
      <button class="apply" @click="applyToPayment">결제내역에 적용</button>
    </div>
    <p v-if="msg" class="msg">{{ msg }}</p>

    <div class="table-scroll">
      <table class="grid">
        <thead>
          <tr>
            <th style="width:44px;">선택</th>
            <th>날짜</th><th>이름</th><th>로그인id</th><th>주문번호</th><th>업무</th>
            <th>결제액</th><th>반품액</th><th>반품철회액</th><th>전체취소액</th>
            <th>PV반환시작일</th><th>PV반환종료일</th><th>PV반환철회시작일</th><th>PV반환철회종료일</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="r in paged" :key="r.id" :class="{ sel: selectedId === r.id }" @click="selectRow(r)">
            <td class="center"><input type="radio" :value="r.id" v-model="selectedId" /></td>
            <td>{{ r.buyDt }}</td>
            <td>{{ r.name }}</td>
            <td>{{ r.loginId }}</td>
            <td>{{ r.orderNo }}</td>
            <td class="center">{{ workLabel(r.work) }}</td>
            <td class="num">{{ fmt(r.amount) }}</td>
            <td class="num">{{ fmt(r.refundAmt) }}</td>
            <td class="num">{{ fmt(r.refundCancelAmt) }}</td>
            <td class="num">{{ fmt(r.allRetAmt) }}</td>
            <td class="center">{{ r.retRangeSt || '-' }}</td>
            <td class="center">{{ r.retRangeEd || '-' }}</td>
            <td class="center">{{ r.retCancelRangeSt || '-' }}</td>
            <td class="center">{{ r.retCancelRangeEd || '-' }}</td>
          </tr>
          <tr v-if="list.length===0"><td colspan="14" class="empty">데이터가 없습니다.</td></tr>
        </tbody>
      </table>
    </div>

    <!-- 페이징 (화면 공통 위젯) -->
    <Paging v-if="list.length > 0" :page="page" :size="size" :total-count="list.length" :total-pages="totalPages"
            @change-page="onPage" @change-size="onSize" />

    <!-- 추가/수정 팝업 -->
    <div v-if="dialogOpen" class="modal-mask" @click.self="dialogOpen=false">
      <div class="modal">
        <div class="modal-head">
          <!-- 스펙107: 팝업 타이틀 "결제내역 수동 저장 목록 편집" -->
          <h4>결제내역 수동 저장 목록 편집 <small class="mode">{{ editId ? '(수정)' : '(추가)' }}</small></h4>
          <div class="head-btns">
            <span class="spacer"></span>
            <!-- 스펙107: 사용자가 검색되지 않으면(로그인id 미설정) 저장 비활성화 -->
            <button class="primary" @click="save" :disabled="!form.loginId">저장</button>
            <button class="ghost" @click="dialogOpen=false">닫기</button>
          </div>
        </div>
        <div class="frm">
          <label>업무</label>
          <span class="work-pick">
            <label v-for="w in workOptions" :key="w.v" class="wopt">
              <input type="radio" :value="w.v" v-model="form.work" @change="onWorkChange" /> {{ w.t }}
            </label>
          </span>
          <label>날짜</label><input v-model="form.buyDt" type="date" />
          <label>이름(로그인id)</label>
          <span class="member-pick">
            <span class="who">{{ form.loginId ? (form.name || '') + '(' + form.loginId + ')' : '(미선택)' }}</span>
            <button class="mini" @click="openMemberSearch">검색</button>
          </span>
          <label>주문번호</label>
          <span class="order-no">
            <span class="order-prefix">{{ orderPrefix }}</span>
            <input v-model="form.orderNoSuffix" type="text" class="order-suffix" placeholder="주문번호 입력" />
          </span>
          <label>결제액</label><input v-model.number="form.amount" type="number" min="0" :disabled="!en('amount')" :class="{ ro: !en('amount') }" />
          <label>반품액</label><input v-model.number="form.refundAmt" type="number" min="0" :disabled="!en('refundAmt')" :class="{ ro: !en('refundAmt') }" />
          <label>반품철회액</label><input v-model.number="form.refundCancelAmt" type="number" min="0" :disabled="!en('refundCancelAmt')" :class="{ ro: !en('refundCancelAmt') }" />
          <label>전체취소액</label><input v-model.number="form.allRetAmt" type="number" min="0" :disabled="!en('allRetAmt')" :class="{ ro: !en('allRetAmt') }" />
        </div>
        <p v-if="dlgErr" class="dl-error">{{ dlgErr }}</p>
      </div>
    </div>

    <!-- 스펙33: 이름/로그인id 는 검색 방식으로 선택 (추가/수정 폼용) -->
    <SearchDialog v-if="memberSearchOpen" @select="onMemberSelect" @close="memberSearchOpen=false" />

    <!-- 스펙201: 결제내역 수동 저장 목록 엑셀 업로드 팝업 -->
    <ManualPurchaseImportDialog v-if="importOpen" @imported="reload" @close="importOpen=false" />

    <!-- 스펙234_개선_14: 불러오기 제외할 cafe24 주문 팝업 -->
    <OrderExcludeDialog v-if="excludeOpen" @close="excludeOpen=false" />

    <!-- 스펙234_개선_14: 결제내역에 적용 완료 팝업 -->
    <div v-if="appliedOpen" class="done-mask" @click.self="appliedOpen=false">
      <div class="done-card">
        <button class="done-x" @click="appliedOpen=false" aria-label="닫기">×</button>
        <div class="done-badge">
          <svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5" /></svg>
        </div>
        <div class="done-title">적용 완료</div>
        <p class="done-msg">결제내역에 반영했습니다.<br />다음날 <b>수당 조회</b>에서 확인하시면 됩니다.</p>
        <button class="done-ok" @click="appliedOpen=false">확인</button>
      </div>
    </div>

    <!-- 스펙54: 반품/반품철회 저장 확인 팝업 - '예' 를 눌러야 임시테이블 저장 실행 -->
    <div v-if="estOpen" class="modal-mask" @click.self="estNo">
      <div class="modal">
        <div class="modal-head">
          <h4>{{ estTitle }}</h4>
          <div class="head-btns"><span class="spacer"></span><button class="ghost" @click="estNo">닫기</button></div>
        </div>
        <p class="pv-msg">범위: {{ estRange }} (본체 + 모든 아바타 사용자)</p>
        <div class="table-scroll">
          <table class="grid">
            <thead><tr><th>사용자</th><th>사용자타입</th><th>예상금액</th></tr></thead>
            <tbody>
              <tr v-for="(n, i) in estRows" :key="i">
                <td>{{ n.label }}</td>
                <td class="center">{{ n.nodeType }}</td>
                <td class="num">{{ fmt(n.pv) }}</td>
              </tr>
              <tr class="total-row"><td>합계</td><td></td><td class="num">{{ fmt(estTotal) }}</td></tr>
            </tbody>
          </table>
        </div>
        <!-- 스펙54: 예 → 저장 실행 / 아니오 → 저장 취소 -->
        <div class="est-confirm">
          <p class="confirm-q">위 내용으로 [결제내역 저장용 임시 테이블]에 저장하시겠습니까?</p>
          <div class="confirm-btns">
            <button class="primary" @click="estYes">예</button>
            <button class="ghost" @click="estNo">아니오</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api';
import { getAuth } from '../store/auth';
import SearchDialog from '../components/SearchDialog.vue';
import Paging from '../components/Paging.vue';
import ManualPurchaseImportDialog from '../components/ManualPurchaseImportDialog.vue';
import OrderExcludeDialog from '../components/OrderExcludeDialog.vue';

function today() {
  const d = new Date();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return d.getFullYear() + '-' + m + '-' + day;
}

// 스펙52: 업무별 입력 필드 활성화 규칙 (1=활성, 0=비활성). 금액 4필드만.
const WORK_ENABLE = {
  P:    { amount: 1, refundAmt: 0, refundCancelAmt: 0, allRetAmt: 0 },
  R:    { amount: 0, refundAmt: 1, refundCancelAmt: 0, allRetAmt: 0 },
  RC:   { amount: 0, refundAmt: 0, refundCancelAmt: 1, allRetAmt: 0 },
  ALLR: { amount: 0, refundAmt: 0, refundCancelAmt: 0, allRetAmt: 1 }
};

// 스펙52: 팝업 폼 초기값 (업무=결제, 금액/전체취소액, PV범위 날짜)
function emptyForm() {
  return {
    // 스펙54: 추가 팝업 금액 초기값은 전부 0 (결제액 154000 표시 버그 수정)
    work: 'P', buyDt: today(), name: '', loginId: '', orderNoSuffix: '',
    amount: 0, refundAmt: 0, refundCancelAmt: 0, allRetAmt: 0
  };
}

export default {
  name: 'ManualPurchase',
  components: { SearchDialog, Paging, ManualPurchaseImportDialog, OrderExcludeDialog },
  props: { hideTitle: { type: Boolean, default: false } },   // 스펙104: 화면2 임베드 시 중복 타이틀 숨김
  data() {
    return {
      startDt: '', endDt: '', fName: '', fLoginId: '', fOrderNo: '',
      topSearchOpen: false,   // 스펙234_개선_18: 상단 검색조건 회원 검색 팝업
      list: [], selectedId: null, selectedRow: null,
      page: 1, size: 10,
      dialogOpen: false, editId: null, dlgErr: '', memberSearchOpen: false, importOpen: false,
      collecting: false, excludeOpen: false, appliedOpen: false,   // 스펙234_개선_14
      estOpen: false, estRows: [], estTitle: '', estRange: '', estConfirm: false, pendingSave: null,
      workOptions: [{ v: 'P', t: '결제' }, { v: 'R', t: '반품' }, { v: 'RC', t: '반품철회' }, { v: 'ALLR', t: '전체취소' }],
      form: emptyForm(),
      msg: ''
    };
  },
  computed: {
    totalPages() { return Math.max(1, Math.ceil(this.list.length / this.size)); },
    paged() {
      const s = (this.page - 1) * this.size;
      return this.list.slice(s, s + this.size);
    },
    estTotal() { return this.estRows.reduce((a, n) => a + Number(n.pv || 0), 0); },
    // 스펙54: 주문번호 고정 접두사 = "M-사용자로그인id-" (고객 선택에 따라 동적). 편집박스는 사용자 입력 전용.
    orderPrefix() { return this.form.loginId ? ('M-' + this.form.loginId + '-') : 'M-'; },
    // 개선2_60: 업로드 버튼은 admin 만 표시
    isAdmin() { return getAuth().role === 'admin'; }
  },
  created() { this.reload(); },
  methods: {
    fmt(n) { return (Number(n || 0)).toLocaleString(); },
    // 스펙234_개선_18: 상단 검색조건 회원 선택 → 입력란(로그인id)을 채우고 재조회
    onTopPick(sel) {
      this.fLoginId = sel.loginId; this.fName = '';
      this.topSearchOpen = false;
      this.reload();
    },
    workLabel(w) { return ({ P: '결제', R: '반품', RC: '반품철회', ALLR: '전체취소' })[w] || (w || '결제'); },
    // 스펙52: 업무별 입력 필드 활성화 여부
    en(field) { return !!(WORK_ENABLE[this.form.work] || WORK_ENABLE.P)[field]; },
    // 스펙54: 업무 라디오 변경 시 금액 4필드 0 으로 초기화
    onWorkChange() {
      this.form.amount = 0; this.form.refundAmt = 0; this.form.refundCancelAmt = 0; this.form.allRetAmt = 0;
    },
    async reload() {
      this.msg = '';
      try {
        const res = await api.manualPurchaseList({
          startDt: this.startDt, endDt: this.endDt, name: this.fName, keyword: this.fLoginId, order_id: this.fOrderNo
        });
        this.list = res.data || [];
        this.selectedId = null; this.selectedRow = null; this.page = 1;
      } catch (e) { this.msg = e.message; this.list = []; }
    },
    onPage(p) { this.page = p; },
    onSize(s) { this.size = s; this.page = 1; },
    selectRow(r) { this.selectedId = r.id; this.selectedRow = r; },
    openMemberSearch() { this.memberSearchOpen = true; },
    onMemberSelect(sel) {
      // 스펙54: 고객 선택 시 고정 접두사(M-로그인id-)만 동적 변경. 편집박스(orderNoSuffix)는 자동변경하지 않음.
      this.form.loginId = sel.loginId;
      this.form.name = sel.name;
      this.memberSearchOpen = false;
    },
    openAdd() {
      this.editId = null; this.dlgErr = '';
      this.form = emptyForm();
      this.dialogOpen = true;
    },
    // 스펙54: 반품/반품철회 저장 확인 팝업. 자동 산출 범위(원결제일~배치일1일전) + 노드별 예상 반환금액을 표시하고
    //   '예' 를 눌러야 임시테이블 저장이 실행된다. (payload 를 보관했다가 estYes 에서 저장)
    async openEstimateConfirm(work, payload) {
      // 스펙105: 반품(R)·전체취소(ALLR)는 '예상 반환금액', 반품철회(RC)는 '예상 반환철회 금액'
      const isRet = work === 'R' || work === 'ALLR';
      try {
        const res = await api.manualEstimateRetPv(payload.loginId, payload.orderNo, payload.buyDt, work);
        const d = res.data || {};
        this.estRows = d.rows || [];
        this.estTitle = isRet ? '예상 반환금액 (사용자별)' : '예상 반환철회 금액 (사용자별)';
        this.estRange = (d.startDt || '-') + ' ~ ' + (d.endDt || '-');
        this.pendingSave = payload;
        this.estConfirm = true;
        this.estOpen = true;
      } catch (e) { this.dlgErr = e.message; }
    },
    // 스펙54: 확인 팝업 '예' → 실제 임시테이블 저장 실행
    async estYes() {
      const payload = this.pendingSave;
      this.estOpen = false; this.estConfirm = false; this.pendingSave = null;
      if (payload) await this.doSave(payload);
    },
    // 스펙54: 확인 팝업 '아니오'/닫기 → 저장하지 않음(추가 팝업은 그대로 유지하여 재편집 가능)
    estNo() {
      this.estOpen = false; this.estConfirm = false; this.pendingSave = null;
    },
    // 임시테이블 저장 실행부(결제/전체취소는 즉시, 반품/반품철회는 '예' 확인 후 호출)
    async doSave(payload) {
      try {
        await api.manualPurchaseSave(payload);
        this.dialogOpen = false;
        this.reload();
      } catch (e) { this.dlgErr = e.message; }
    },
    async applyToPayment() {
      if (this.list.length === 0) { this.msg = '적용할 임시 저장 내역이 없습니다.'; return; }
      if (!window.confirm('임시 저장된 내용을 결제내역에 적용하시겠습니까?')) return;
      this.msg = '';
      try {
        const res = await api.manualPurchaseApply();
        this.msg = (res.data || 0) + '건을 결제내역에 적용했습니다.';
        this.reload();
        this.$emit('applied');   // 스펙54: 화면2 상단(결제내역 조회) 재조회 트리거
        this.appliedOpen = true; // 스펙234_개선_14: 적용 완료 팝업
      } catch (e) { this.msg = e.message; }
    },
    // 스펙234_개선_14: 전체삭제 - [결제내역 저장용 임시 테이블] 전체 삭제
    async removeAll() {
      if (!window.confirm('임시 테이블 전체를 삭제하시겠습니까?')) return;
      try { await api.manualPurchaseDeleteAll({}); this.selectedId = null; this.reload(); }
      catch (e) { this.msg = e.message; }
    },
    // 스펙234_개선_14: 불러오기 - 확인 후 [Cafe24 주문·환불 조회 배치] 실행(dt=오늘) → 하단 목록 재조회
    async collectReceive() {
      if (this.collecting) return;
      if (!window.confirm('고객의 주문건을 cafe24 에서 불러와 전산의 아래 목록에 저장합니다. 실행하시겠습니까?')) return;
      this.collecting = true; this.msg = '';
      try {
        const res = await api.orderReceiveCollect(today());
        this.msg = (res && res.message) ? res.message : '주문 불러오기 완료';
        this.reload();
      } catch (e) {
        this.msg = (e && e.response && e.response.data && e.response.data.message) || e.message || '주문 불러오기 실패';
      } finally {
        this.collecting = false;
      }
    },
    async openEdit() {
      if (!this.selectedId) { this.msg = '수정할 항목을 선택하세요.'; return; }
      this.dlgErr = '';
      try {
        const res = await api.manualPurchaseGet(this.selectedId);
        const d = res.data || {};
        this.editId = this.selectedId;
        // 스펙54: 기존 주문번호에서 접두사("M-로그인id-")를 떼어낸 나머지를 편집박스에 로드
        const prefix = 'M-' + (d.loginId || '') + '-';
        const fullNo = d.orderNo || '';
        const suffix = fullNo.indexOf(prefix) === 0 ? fullNo.substring(prefix.length) : fullNo;
        this.form = {
          work: d.work || 'P',
          buyDt: d.buyDt || today(), name: d.name || '', loginId: d.loginId || '', orderNoSuffix: suffix,
          amount: Number(d.amount || 0), refundAmt: Number(d.refundAmt || 0),
          refundCancelAmt: Number(d.refundCancelAmt || 0), allRetAmt: Number(d.allRetAmt || 0)
        };
        this.dialogOpen = true;
      } catch (e) { this.msg = e.message; }
    },
    async save() {
      this.dlgErr = '';
      if (!this.form.loginId) { this.dlgErr = '로그인id를 입력하세요.'; return; }
      if (!this.form.buyDt) { this.dlgErr = '날짜를 입력하세요.'; return; }
      // 스펙54: 주문번호 편집박스가 비어있으면 저장 막음. 최종 주문번호 = 접두사 + 입력값
      if (!String(this.form.orderNoSuffix || '').trim()) { this.dlgErr = '주문번호를 입력하세요.'; return; }
      const fullOrderNo = this.orderPrefix + String(this.form.orderNoSuffix).trim();
      // 스펙52: PV 범위는 백엔드가 업무별로 자동 설정. 화면은 업무/금액만 전송.
      const payload = {
        id: this.editId, work: this.form.work, loginId: this.form.loginId, buyDt: this.form.buyDt, orderNo: fullOrderNo,
        amount: this.form.amount, refundAmt: this.form.refundAmt, refundCancelAmt: this.form.refundCancelAmt,
        allRetAmt: this.form.allRetAmt
      };
      const w = this.form.work;
      // 스펙105: 반품(R)·전체취소(ALLR)·반품철회(RC)는 예상 반환(철회)금액 팝업에서 '예' 를 눌러야 임시테이블 저장이 실행됨.
      if (w === 'R' || w === 'RC' || w === 'ALLR') { this.openEstimateConfirm(w, payload); return; }
      // 결제(P): 즉시 저장
      this.doSave(payload);
    },
    async removeOne() {
      if (!this.selectedId) { this.msg = '삭제할 항목을 선택하세요.'; return; }
      if (!window.confirm('선택한 항목을 삭제하시겠습니까?')) return;
      try { await api.manualPurchaseDelete(this.selectedId); this.reload(); }
      catch (e) { this.msg = e.message; }
    }
  }
};
</script>

<style scoped>
.page { padding: 4px; }
.toolbar { display: flex; align-items: center; gap: 8px; margin: 12px 0; flex-wrap: wrap; }
.toolbar label { font-size: 13px; color: #33405c; font-weight: 600; }
.toolbar input[type="date"] { height: 30px; border: 1px solid #cfd6e6; border-radius: 6px; padding: 0 8px; }
.toolbar input.tin { height: 30px; border: 1px solid #cfd6e6; border-radius: 6px; padding: 0 8px; width: 120px; }
.toolbar .dash { color: #8a95ab; }
.toolbar button.recv { background: #2e8b57; border-color: #2e8b57; color: #fff; }
.toolbar button.recv:disabled { opacity: .55; cursor: default; }
.toolbar button.apply { background: #c0392b; border-color: #c0392b; color: #fff; }
/* 세련된 완료 팝업 */
.done-mask { position: fixed; inset: 0; background: rgba(17,24,39,.45); display: flex; align-items: center; justify-content: center; z-index: 60; }
.done-card { position: relative; background: #fff; border-radius: 16px; width: 380px; max-width: 92vw; padding: 30px 26px 24px; text-align: center;
             box-shadow: 0 18px 50px rgba(0,0,0,.22); animation: doneIn .18s ease-out; }
@keyframes doneIn { from { opacity: 0; transform: translateY(8px) scale(.98); } to { opacity: 1; transform: none; } }
.done-x { position: absolute; top: 10px; right: 12px; width: 30px; height: 30px; border: none; background: transparent; color: #9aa4b2; font-size: 22px; line-height: 1; cursor: pointer; }
.done-x:hover { color: #4b5563; }
.done-badge { width: 62px; height: 62px; margin: 4px auto 14px; border-radius: 50%; background: linear-gradient(135deg,#34c76a,#1f9d55);
              display: flex; align-items: center; justify-content: center; box-shadow: 0 8px 20px rgba(31,157,85,.35); }
.done-title { font-size: 19px; font-weight: 800; color: #1f2937; letter-spacing: -.2px; }
.done-msg { font-size: 13.5px; color: #4b5563; line-height: 1.6; margin: 8px 0 20px; }
.done-msg b { color: #1f2937; }
.done-ok { height: 40px; min-width: 120px; padding: 0 22px; border: none; border-radius: 10px; background: #1f9d55; color: #fff;
           font-size: 14px; font-weight: 700; cursor: pointer; }
.done-ok:hover { background: #18864a; }
.toolbar button.run { background: #1f9d55; border-color: #1f9d55; color: #fff; }
.toolbar button.run:disabled { opacity: 0.5; cursor: not-allowed; }
.toolbar button { height: 30px; border: 1px solid #4d8bff; background: #4d8bff; color: #fff; border-radius: 6px; padding: 0 14px; cursor: pointer; font-size: 13px; }
.toolbar button.ghost { background: #fff; color: #33405c; border-color: #cfd6e6; }
.toolbar button.ghost:hover { background: #eef3fb; }
.toolbar button.danger { color: #c0392b; border-color: #edb8b2; }
.toolbar .spacer { flex: 1; }
.msg { color: #c0392b; font-size: 13px; margin: 4px 0; }
.table-scroll { overflow-x: auto; }
.grid { width: 100%; border-collapse: collapse; font-size: 13px; }
.grid th, .grid td { border: 1px solid #e4e9f2; padding: 6px 8px; white-space: nowrap; }
.grid thead th { background: #f2f5fb; color: #33405c; }
.grid td.num { text-align: right; }
.grid td.center { text-align: center; }
.grid tr.total-row td { background: #eef3fb; font-weight: 700; }
.grid tr.sel td { background: #fff6e0; }
.mtag { display: inline-block; margin-left: 6px; padding: 1px 6px; font-size: 10.5px; background: #eaf1ff; color: #2f6fed; border-radius: 8px; vertical-align: middle; }
.grid .empty { text-align: center; color: #8a95ab; padding: 20px; }
.modal-mask { position: fixed; inset: 0; background: rgba(15,22,40,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.modal { background: #fff; border-radius: 10px; padding: 20px 24px; width: 560px; max-width: 94vw; box-shadow: 0 12px 40px rgba(0,0,0,0.3); }
.modal h4 { margin: 0 0 14px; color: #1f2a44; }
.modal-head { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 8px; flex-wrap: wrap; }
.modal-head h4 { margin: 0; }
.head-btns { display: flex; align-items: center; gap: 8px; flex: 1; }
.head-btns .spacer { flex: 1; }
.head-btns button { height: 30px; border-radius: 6px; padding: 0 12px; cursor: pointer; font-size: 13px; border: 1px solid #cfd6e6; background: #fff; color: #33405c; }
.head-btns button.primary { background: #4d8bff; color: #fff; border: none; }
.head-btns button:disabled { opacity: 0.5; cursor: not-allowed; }
.pv-msg { color: #1f7a44; font-size: 13px; margin: 2px 0 10px; font-weight: 600; }
.frm { display: grid; grid-template-columns: 90px 1fr; gap: 10px 10px; align-items: center; }
.frm label { font-size: 13px; color: #33405c; }
.frm input { height: 30px; border: 1px solid #cfd6e6; border-radius: 6px; padding: 0 8px; font-size: 13px; }
.frm input.ro { background: #f4f6fa; }
.work-pick { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; }
.work-pick .wopt { display: inline-flex; align-items: center; gap: 4px; font-size: 13px; color: #33405c; cursor: pointer; }
.order-no { display: flex; align-items: center; gap: 4px; }
.order-no .order-prefix { font-size: 13px; color: #33405c; white-space: nowrap; font-weight: 600; }
.order-no .order-suffix { flex: 1; min-width: 80px; }
.member-pick { display: flex; align-items: center; gap: 8px; }
.member-pick .who { font-size: 13px; color: #1f2a44; }
.member-pick .mini { height: 28px; border: none; background: #4d8bff; color: #fff; border-radius: 6px; padding: 0 12px; cursor: pointer; font-size: 12px; }
.dl-error { color: #c0392b; font-size: 13px; margin: 10px 0 0; }
.modal-btns { display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px; }
.modal-btns button { height: 32px; border-radius: 6px; padding: 0 16px; cursor: pointer; font-size: 13px; border: 1px solid #cfd6e6; background: #fff; color: #33405c; }
.modal-btns button.primary { background: #4d8bff; color: #fff; border: none; }
/* 스펙54: 반품/반품철회 저장 확인(예/아니오) 블록 */
.est-confirm { margin-top: 14px; border-top: 1px solid #eef2f8; padding-top: 12px; }
.est-confirm .confirm-q { font-size: 13px; color: #1f2a44; font-weight: 600; margin: 0 0 10px; text-align: center; }
.est-confirm .confirm-btns { display: flex; justify-content: center; gap: 10px; }
.est-confirm .confirm-btns button { height: 32px; border-radius: 6px; padding: 0 22px; cursor: pointer; font-size: 13px; border: 1px solid #cfd6e6; background: #fff; color: #33405c; }
.est-confirm .confirm-btns button.primary { background: #4d8bff; color: #fff; border: none; }
</style>
